import React, { useEffect, useState } from 'react';
import { SearchBar } from '../../SearchBar/SearchBar';
import { useQuery } from 'react-query';
import { useDebounce } from '../../hooks/useDebounce/useDebounce';
import { usePublicApiClient } from '../../hooks/usePublicApiClient';
import { useNavigate } from '../../PlatformFunctionality';
import { ContentfulSupportArticle } from '@jbhi-fi/apis/src/contentful/types';

const MAX_SEARCH_RESULTS = 6;

export const HelpAndSupportSearch = ({ searchKey }: { searchKey?: string }) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const debouncedTerm = useDebounce(searchTerm, 300);
  const { contentfulThemeApiClient } = usePublicApiClient();
  const navigate = useNavigate();

  useEffect(() => {
    if (searchKey) {
      setSearchTerm(searchKey);
    }
  }, [searchKey]);

  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ['HelpAndSupport', 'search', debouncedTerm],
    queryFn: async () => {
      const response = await contentfulThemeApiClient?.getEntries<ContentfulSupportArticle>({
        content_type: 'supportArticle',
        'fields.heading[match]': debouncedTerm,
        select: 'fields.heading,fields.urlSlug',
        include: '1',
      });

      if (!response?.data?.items) return;

      return response.data.items.map(item => {
        return {
          title: item.fields?.heading || '',
          onClick: () => navigate(item.fields?.urlSlug || ''),
        };
      });
    },
    refetchOnWindowFocus: false,
    enabled: debouncedTerm.trim().length > 1 && debouncedTerm !== searchKey,
  });

  return (
    <SearchBar
      placeholder="Search support articles"
      isLoading={isLoading}
      hasFetchedResults={isSuccess}
      value={searchTerm}
      onChange={setSearchTerm}
      onSearch={query => navigate(`/search?query=${query}`)}
      results={data}
      maxResults={MAX_SEARCH_RESULTS}
    />
  );
};
